import React from "react";
import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, GradeLevelOptions, getGradeOptions } from "../../../../../../_helpers/Helpers";

export function LevelSectionEditForm({ 
  gradeOptions,
  levelSection,
  btnRef,
  setGradeOptions,  
  saveLevelSection
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={levelSection}
      onSubmit={(values) => {
        if (values.capacity === "") values.capacity = null;
        saveLevelSection(values);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="course">
            <Form.Label column sm={2}>
              Ders<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={levelSection.courses}
                value={values.courseId}
                onChange={option => setFieldValue("courseId", option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="gradeLevel">
            <Form.Label column sm={2}>
              Sınıf Düzeyi<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect 
                options={GradeLevelOptions}
                value={values.gradeLevel}
                onChange={option => {
                  const options = getGradeOptions(option.value);
                  setGradeOptions(options);
                  setFieldValue("gradeLevel", option.value);
                  if (options.length === 1) setFieldValue("grade", options[0].value);
                  else if (!options.map(option => option.value).includes(values.grade)) setFieldValue("grade", null);
                }}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="grade">
            <Form.Label column sm={2}>
              Kur Sınıfı<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <CustomSelect
                options={gradeOptions}
                value={values.grade}
                onChange={option => setFieldValue("grade", option.value)}
              />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={2}>
              Kur<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.name} placeholder="Kur" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="capacity">
            <Form.Label column sm={2}>
              Kapasite<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="number" min="1" value={values.capacity} placeholder="Kapasite" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}